import * as React from "react";

import { GrayBackground } from "@/stf.ui/layout.main";

interface HtmlProps
  extends React.DetailedHTMLProps<React.HtmlHTMLAttributes<HTMLHtmlElement>, HTMLHtmlElement> {}
const Html = (props: HtmlProps) => {
  const {
    children,
    lang = "en",
    ...rest
  } = props;
  return (
    <html
      lang={lang}
      suppressHydrationWarning
      {...rest}
    >
      {children}
    </html>
  );
};

interface HeadProps
  extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLHeadElement>, HTMLHeadElement> {}
const Head = (props: HeadProps) => {
  const { children, ...rest } = props;
  return (
    <head {...rest}>
      <link rel="icon" type="image/png" href="/favicon/favicon-48x48.png" sizes="48x48" />
      <link rel="icon" type="image/svg+xml" href="/favicon/favicon.svg" />
      <link rel="shortcut icon" href="/favicon.ico" />
      <link rel="apple-touch-icon" sizes="180x180" href="/favicon/apple-touch-icon.png" />
      {children}
    </head>
  );
};

interface BodyProps
  extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLBodyElement>, HTMLBodyElement> {}
const Body = (props: BodyProps) => {
  const { children, ...rest } = props;
  return (
    <body {...rest}>
      <GrayBackground />
      {children}
    </body>
  );
};

export {
  Body,
  Head,
  Html,
};
